import { motion } from "framer-motion";
import { Waves, Shield, Infinity as InfinityIcon } from "lucide-react";

const pillars = [
  {
    icon: Waves,
    title: "Coherence",
    body: "The state where your inner and outer life move as one — emotion, thought, body, and energy aligned to a single true frequency. Not just stability, but active harmony across everything you are and do.",
  },
  {
    icon: Shield,
    title: "Sovereignty",
    body: "Mastery of your own field. The ability to stay rooted in your true frequency regardless of external pressure, noise, or interference. Not isolation — autonomy.",
  },
];

export default function Philosophy() {
  return (
    <section id="philosophy" data-testid="philosophy-section" className="relative py-24 md:py-32 bg-[#281620] text-[#f7efe2] overflow-hidden grain">
      <div className="max-w-5xl mx-auto px-6 relative z-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <p className="font-accent text-sm tracking-widest-2 uppercase text-[#c2a04b] mb-4">The living architecture</p>
          <h2 className="font-display text-4xl md:text-5xl leading-tight">Coherence & Sovereignty</h2>
        </div>

        <div className="grid md:grid-cols-2 gap-7">
          {pillars.map((p, i) => (
            <motion.div
              key={p.title}
              data-testid={`pillar-${p.title.toLowerCase()}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              className="rounded-2xl p-8 border border-[#e3b4b0]/25 bg-[#f7efe2]/5 backdrop-blur-sm"
            >
              <div className="w-12 h-12 rounded-full bg-[#b76e79]/30 flex items-center justify-center mb-5">
                <p.icon size={22} className="text-[#e3b4b0]" />
              </div>
              <h3 className="font-display text-3xl text-[#f7efe2] mb-3">{p.title}</h3>
              <p className="text-[#f7efe2]/75 leading-relaxed">{p.body}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-7 rounded-2xl p-8 border border-[#c2a04b]/30 bg-[#b76e79]/15 text-center max-w-3xl mx-auto"
        >
          <div className="w-12 h-12 rounded-full bg-[#c2a04b]/25 flex items-center justify-center mb-4 mx-auto">
            <InfinityIcon size={22} className="text-[#c2a04b]" />
          </div>
          <h3 className="font-display text-3xl text-[#f7efe2] mb-3">Together</h3>
          <p className="text-[#f7efe2]/80 leading-relaxed">
            Coherence without sovereignty collapses under outside force. Sovereignty without
            coherence becomes rigidity. Together they form the living architecture of a life —
            and a mission — that holds.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
